import { useTranslation } from 'react-i18next';

export default function LendingSecuritySection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('lending.security.title')}
          </h2>
          <p className="text-xl text-gray-300">
            {t('lending.security.subtitle')}
          </p>
        </div>

        <div className="mb-12">
          <img 
            src="https://public.readdy.ai/ai/img_res/c2d3773fe2629c6a48218137e7b095cd.jpg"
            alt="DP Lending App on iPhone"
            className="w-full max-w-3xl mx-auto"
          />
        </div>

        <div className="bg-gray-900 rounded-2xl p-8 border border-gray-700 mb-12">
          <p className="text-gray-300 text-lg leading-relaxed text-center">
            {t('lending.security.desc')}
          </p>
        </div>

        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold text-yellow-400 mb-8">
            {t('lending.security.bankLevel')}
          </h3>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 text-center">
            <img 
              src="https://mycoinlending.com/images/security-1.png"
              alt="SSL/TLS"
              className="w-24 h-24 mx-auto mb-4"
            />
            <h4 className="text-white font-bold">
              {t('lending.security.feature1')}
            </h4>
          </div>

          <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 text-center">
            <img 
              src="https://mycoinlending.com/images/security-2.png"
              alt="2FA"
              className="w-24 h-24 mx-auto mb-4"
            />
            <h4 className="text-white font-bold">
              {t('lending.security.feature2')}
            </h4>
          </div>

          <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 text-center">
            <img 
              src="https://mycoinlending.com/images/security-3.png"
              alt="Auto Logout"
              className="w-24 h-24 mx-auto mb-4"
            />
            <h4 className="text-white font-bold">
              {t('lending.security.feature3')}
            </h4>
          </div>

          <div className="bg-gray-900 rounded-xl p-6 border border-gray-700 text-center">
            <img 
              src="https://mycoinlending.com/images/security-4.png"
              alt="Monitoring"
              className="w-24 h-24 mx-auto mb-4"
            />
            <h4 className="text-white font-bold">
              {t('lending.security.feature4')}
            </h4>
          </div>
        </div>
      </div>
    </section>
  );
}
